"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = require("graphql-tag");
const Environment_1 = require("../Environment");
const handleError_1 = require("../Environment/handleError");
const index_1 = require("../reducers/index");
const getCampaignType_1 = require("../views/utils/getCampaignType");
const util_1 = require("./util");
exports.fetchSegments = () => (dispatch) => {
    dispatch({ type: 'FETCH_SEGMENTS_REQUEST' });
    const query = graphql_tag_1.default `
            query Segments($archivedStatus: String!) {
                dynamicSegment(archivedStatus: $archivedStatus) {
                    isArchived
                    segmentId
                    name
                }
            }
        `;
    const request = {
        query,
        variables: {
            archivedStatus: 'ALL',
        },
    };
    return Environment_1.default(request).then(({ data, errors }) => {
        if (errors) {
            return handleError_1.default('FETCH_SEGMENTS_FAILURE', dispatch, errors[0].message);
        }
        return dispatch({
            type: 'FETCH_SEGMENTS_SUCCESS',
            segments: data.dynamicSegment.reduce((segments, segment) => (Object.assign(Object.assign({}, segments), { [segment.segmentId]: segment })), {}),
        });
    }, ({ result }) => handleError_1.default('FETCH_SEGMENTS_FAILURE', dispatch, result.errors[0].message));
};
exports.fetchNextAudienceSize = (segmentIds) => (dispatch, getState) => {
    dispatch({ type: 'FETCH_NEXT_AUDIENCE_SIZE_REQUEST' });
    const query = graphql_tag_1.default `
            query SegmentSize($segmentIds: [ID!]!, $condition: String!) {
                segmentSize(segmentIds: $segmentIds, condition: $condition)
            }
        `;
    const state = getState();
    const segment = index_1.getEditableCampaignSegment(state);
    const request = {
        query,
        variables: {
            segmentIds: segment ? segment.ids : [],
            condition: segment ? segment.condition : 'ANY',
        },
    };
    return Environment_1.default(request).then(({ data, errors }) => {
        if (errors) {
            return handleError_1.default('FETCH_NEXT_AUDIENCE_FAILURE', dispatch, errors[0].message);
        }
        return dispatch({
            type: 'FETCH_NEXT_AUDIENCE_SIZE_SUCCESS',
            audience: Object.assign(Object.assign({}, state.app.audience), { [segmentIds[0]]: data.segmentSize }),
        });
    }, ({ result }) => handleError_1.default('FETCH_NEXT_AUDIENCE_FAILURE', dispatch, result.errors[0].message));
};
exports.fetchAudienceSize = () => (dispatch, getState) => {
    dispatch({ type: 'FETCH_AUDIENCE_SIZE_REQUEST' });
    const query = graphql_tag_1.default `
            query SegmentSize {
                totalSize: segmentSize(segmentIds: [], condition: "ANY")
            }
        `;
    const request = {
        query,
    };
    return Environment_1.default(request).then(({ data, errors }) => {
        if (errors) {
            return handleError_1.default('FETCH_AUDIENCE_SIZE_FAILURE', dispatch, errors[0].message);
        }
        return dispatch({
            type: 'FETCH_AUDIENCE_SIZE_SUCCESS',
            audience: Object.assign(Object.assign({}, getState().app.audience), data),
        });
    }, ({ result }) => handleError_1.default('FETCH_AUDIENCE_SIZE_FAILURE', dispatch, result.errors[0].message));
};
exports.fetchAudienceSizes = () => (dispatch, getState) => {
    dispatch({ type: 'FETCH_AUDIENCE_SIZE_REQUEST' });
    const state = getState();
    const { trigger } = index_1.getEditableCampaign(state);
    const { segment } = trigger;
    if (!getCampaignType_1.isAutomatedCampaignTrigger(trigger) &&
        !getCampaignType_1.isScheduledCampaignTrigger(trigger) &&
        !getCampaignType_1.isAPICampaignTrigger(trigger)) {
        return Promise.resolve();
    }
    const segmentIds = segment ? segment.ids : [];
    const queriesById = segmentIds
        .map((id, index, array) => {
        const ids = array.slice(0, index + 1).reverse();
        return `x${id}: segmentSize(segmentIds: ${JSON.stringify(ids)}, condition: $condition)`;
    })
        .concat([`totalSize: segmentSize(segmentIds: [], condition: $condition)`])
        .join('\n');
    const query = graphql_tag_1.default `
        query SegmentSize($condition: String!) {
            ${queriesById}
        }
    `;
    const request = {
        query,
        variables: {
            condition: segment ? segment.condition : 'ANY',
        },
    };
    return Environment_1.default(request).then(({ data, errors }) => {
        if (errors) {
            return handleError_1.default('FETCH_AUDIENCE_SIZE_FAILURE', dispatch, errors[0].message);
        }
        return dispatch({
            type: 'FETCH_AUDIENCE_SIZE_SUCCESS',
            audience: Object.keys(data).reduce((prev, curr) => (Object.assign(Object.assign({}, prev), { [curr === 'totalSize' ? 'totalSize' : curr.slice(1)]: data[curr] })), Object.assign({}, getState().app.audience)),
        });
    }, ({ result }) => handleError_1.default('FETCH_AUDIENCE_SIZE_FAILURE', dispatch, result.errors[0].message));
};
exports.fetchDeviceTotalSize = () => (dispatch, getState) => {
    dispatch({ type: 'FETCH_DEVICE_TOTAL_SIZE_REQUEST' });
    const query = graphql_tag_1.default `
            query DeviceListSize($predicate: PredicateInput) {
                devices(predicate: $predicate) {
                    totalCount
                }
            }
        `;
    const state = getState();
    const segment = index_1.getEditableCampaignSegment(state);
    let predicate;
    if (segment) {
        switch (segment.__typename) {
            case 'DeviceListSegment':
                predicate = {
                    keyPath: segment.keyPath,
                    modifier: 'DIRECT',
                    operator: 'IN_LIST',
                    value: {
                        listValue: {
                            id: parseInt(segment.deviceList.id),
                        },
                    },
                };
                break;
            case 'DevicePredicateSegment':
                predicate = segment.predicate ? util_1.predicateToInput(segment.predicate) : undefined;
                break;
        }
    }
    const request = {
        query,
        variables: {
            predicate,
        },
    };
    return Environment_1.default(request).then(({ data, errors }) => {
        if (errors) {
            return handleError_1.default('FETCH_DEVICE_TOTAL_SIZE_FAILURE', dispatch, errors[0].message);
        }
        return dispatch({
            type: 'FETCH_DEVICE_TOTAL_SIZE_SUCCESS',
            totalCount: data.devices.totalCount,
        });
    }, ({ result }) => handleError_1.default('FETCH_DEVICE_TOTAL_SIZE_FAILURE', dispatch, result.errors[0].message));
};
